import {registerComponent} from '../../shared/react/registrar';
import {SearchPage} from '../../shared/search/search-result/SearchPage';

registerComponent(SearchPage, `SearchPage`);
